<template>
  <div
    :class="['media-articles', 'pb-3xl', isPartial ? 'is-partial' : 'is-page']"
  >
    <h2
      :class="[
        'pt-2xl',
        'heading__2',
        'heading__lined',
        'font-300',
        !isPartial ? 'px-2xl' : ''
      ]"
      v-if="title"
      v-text="title"
    ></h2>
    <search-bar v-if="!isPartial" v-model="searchInput" />
    <transition-group
      tag="div"
      :css="false"
      :class="[
        'media-articles--items',
        'clearfix',
        !isPartial ? 'container' : ''
      ]"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
      appear
      v-if="filteredChildren.length"
    >
      <div
        v-for="(item, index) in filteredChildren"
        :data-index="index"
        :key="item.title + index"
        class="media-articles--item pt-3xl text-left"
      >
        <!-- <i class="fas fa-book-open flex-none pt-s"></i> -->
        <div class="media-articles--item--content flex-1">
          <h3 class="pb-m" v-text="item.title"></h3>
          <h5 v-text="item.sub_title"></h5>
          <abtn
            v-if="item.url"
            :url="item.url"
            :class="['media-articles--item--link', 'float-left', 'mt-xl']"
            link-mode
          >
            <span v-text="localize('view_publication')"></span>
          </abtn>
        </div>
      </div>
    </transition-group>
    <h3 class="container pt-3xl" v-else>No Items Found.</h3>
  </div>
</template>

<script>
// import
import { sameDomain } from "@/utils";
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    /*
      True in case the component is a partial (not minified version)
      and not expanded on a whole page
    */
    isPartial: {
      type: Boolean,
      default: false
    },
    css: String
  },
  data() {
    return {
      sameDomain,
      searchInput: ""
    };
  },
  components: {
    "search-bar": () => import("@/components/media/MediaSearchBar.vue")
  },
  methods: {
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(20%)";
    },
    enter: function(el, done) {
      let lapse = 120,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(20%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    }
  },
  computed: {
    filteredChildren() {
      let search = this.searchInput;
      if (search.length < 2) {
        return this.children;
      }
      return _.filter(this.children, item => {
        let string = item.title + item.sub_title;
        return string.toLowerCase().indexOf(search.toLowerCase()) > -1;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.media-articles--item
  _flex(row, nowrap, flex-start, flex-start)
  &--content
    /.is-page &
      pad('2xl', bottom)
      border-bottom 1px solid blue_4
  &--link
    /.el-size--small &
      marg('xl', top)
    /.el-size--medium &
      marg('2xl', top)
  h5
    line-height 1.2
</style>
